<div *ngIf="!dismiss" class="cardwrapper">
    <mat-card>
        <ng-content></ng-content>
    </mat-card>
</div>